import { Alert, AlertTitle } from '@mui/material';
import { lazy, Suspense } from 'react';
import { createBrowserRouter, Link, Outlet } from 'react-router-dom';
import { RoleBasedPrivateRoute } from 'src/RoleBasedPrivateRoute';
import { ROUTES } from 'src/routes';
import { RouteWithAuth } from 'src/RouteWithAuth';
import { AppWrapper } from './AppWrapper';
import { ActionPage } from './auth/ActionPage';
import FeatureLanding from './FeatureLanding';
import { TermsPage } from './Terms';

const Workspace = lazy(() =>
  import('src/workspace/Workspace').then((module) => ({
    default: module.Workspace,
  })),
);
const DesignPage = lazy(() =>
  import('src/designs/DesignPage').then((module) => ({
    default: module.DesignPage,
  })),
);
const Account = lazy(() =>
  import('src/Account').then((module) => ({ default: module.Account })),
);
const AdminUsers = lazy(() =>
  import('src/admin/AdminUsers').then((module) => ({
    default: module.AdminUsers,
  })),
);
const CatalogManager = lazy(() =>
  import('./admin/CatalogManager').then((module) => ({
    default: module.CatalogManager,
  })),
);

export const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <FeatureLanding />,
  },
  {
    path: ROUTES.TERMS,
    element: <TermsPage />,
  },

  // {
  //   path: ROUTES.DOCUMENTATION,
  //   element: <Documentation />,
  //   children: docSections,
  // },
  {
    path: ROUTES.AUTH_ACTION,
    element: <ActionPage />,
  },
  {
    path: ROUTES.APP,
    element: (
      <RouteWithAuth>
        <Suspense fallback={<div>Loading...</div>}>
          <AppWrapper />
        </Suspense>
      </RouteWithAuth>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Workspace />
          </Suspense>
        ),
      },
      {
        path: 'space',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Workspace />
          </Suspense>
        ),
      },
      {
        path: 'space/:folderId',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Workspace />
          </Suspense>
        ),
      },
      {
        path: 'account',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Account />
          </Suspense>
        ),
      },
      {
        path: 'admin',
        element: (
          <RoleBasedPrivateRoute requiredRole="admin">
            <Suspense fallback={<div>Loading...</div>}>
              <Outlet />
            </Suspense>
          </RoleBasedPrivateRoute>
        ),
        children: [
          {
            path: '',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AdminUsers />
              </Suspense>
            ),
          },
          {
            path: 'users',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AdminUsers />
              </Suspense>
            ),
          },
          {
            path: 'catalogs',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <CatalogManager />
              </Suspense>
            ),
          },
          // {
          //   path: 'nozzles',
          //   element: <Nozzles />,
          // },
        ],
      },
    ],
  },
  {
    path: 'w/design/:id',
    element: (
      <RouteWithAuth>
        <Suspense fallback={<div>Loading...</div>}>
          <DesignPage />
        </Suspense>
      </RouteWithAuth>
    ),
  },
  {
    path: '*',
    element: (
      <div style={{ flex: 1, padding: 24, textAlign: 'center' }}>
        <Alert severity="error">
          <AlertTitle>Page not found</AlertTitle>
          Try going somewhere else?
        </Alert>
        <Link to={ROUTES.HOME}>Home Page</Link>
      </div>
    ),
  },
]);
